import { ChevronDown, ChevronLeft, ChevronRight, ChevronUp } from "lucide-react";

/** Navigation chevron shared by `ColocaDateField` and `ColocaDateRangeField` calendars. */
export function DayPickerChevron({ orientation }: { orientation?: "up" | "down" | "left" | "right" }) {
  if (orientation === "left") return <ChevronLeft className="h-4 w-4" />;
  if (orientation === "right") return <ChevronRight className="h-4 w-4" />;
  if (orientation === "up") return <ChevronUp className="h-3 w-3" />;
  return <ChevronDown className="h-3 w-3" />;
}
